import { GeoPoint } from 'firebase/firestore';
import { useState, useEffect, useCallback } from 'react';
import { remotePickMealPointListener } from '~/firebase/listeners/platform';

import { emptyOperatingTime, FirebaseDataStatus } from '~/types/utilities';
import { PLATFORM_ID } from '~/globalVariables';

// types
import { SnapshotFn } from '~/firebase/listeners/type';
import { RemotePickMealPoint } from '~/types/platform/remotePickMealPoint';

export default function usePickMealPoint(pointId: string) {
  const [dataStatus, setDataStatus] = useState(FirebaseDataStatus.INIT);
  const [remotePickMealPoint, setRemotePickMealPoint] = useState<RemotePickMealPoint>({
    name: '',
    image: '',
    description: '',
    phoneNumber: '',
    operatingTime: emptyOperatingTime,
    stores: [],
    location: {
      address: '',
      geoPoint: new GeoPoint(0, 0),
    },
    shippingFeeSetting: {
      baseFee: 0,
      freeLimit: Infinity,
      rates: [],
      priceThreshold: [],
      subsidies: [],
      cashHandlingFeeForCustomer: 0,
    },
  });

  const handleSnapshot = useCallback<SnapshotFn>(
    (doc) => {
      const data = doc.data() as RemotePickMealPoint | undefined;

      if (!doc.exists() || !data) {
        setDataStatus(FirebaseDataStatus.NOT_EXIST);
        return;
      }

      setDataStatus(FirebaseDataStatus.EXIST);
      setRemotePickMealPoint(data);
    },
    [setDataStatus],
  );

  useEffect(() => {
    const unlisten = remotePickMealPointListener(PLATFORM_ID, pointId, handleSnapshot);

    return () => {
      unlisten();
    };
  }, [pointId]);

  return {
    remotePickMealPoint,
    dataStatus,
  };
}
